import { render, staticRenderFns } from "./open-student.vue?vue&type=template&id=66b4711d&scoped=true"
import script from "./open-student.vue?vue&type=script&lang=js"
export * from "./open-student.vue?vue&type=script&lang=js"
import style0 from "./open-student.vue?vue&type=style&index=0&id=66b4711d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4711d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b4711d')) {
      api.createRecord('66b4711d', component.options)
    } else {
      api.reload('66b4711d', component.options)
    }
    module.hot.accept("./open-student.vue?vue&type=template&id=66b4711d&scoped=true", function () {
      api.rerender('66b4711d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/components/open-student.vue"
export default component.exports